import script from "./NewsfeedCreatorDiscussionTab.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsfeedCreatorDiscussionTab.vue?vue&type=script&setup=true&lang=js"

import "./NewsfeedCreatorDiscussionTab.vue?vue&type=style&index=0&id=63276b64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63276b64"]])

export default __exports__